import * as React from 'react'
import checkUrlType from '../../../../../utils/url-type-checker';
import * as cn from 'classnames'
import { PackshotProps } from './Packshot';

interface PackshotContainerProps extends PackshotProps {
  classNames: string
  style?: React.CSSProperties
  children: React.ReactChild | React.ReactChild[]
}

const hasLinkProps = (props: PackshotContainerProps) => {
  if (!props.link) {
    return false
  }
  if (props.isLive && !props.canLivePlayback) {
    // if the user browser is too old, we'll display an error message on the click
    if (!props.playbackAction) {
      // except if the user isn't entitled, in which case we will redirect to the sign up page
      return true
    }
    return false
  }
  return true
}

const PackshotContainer = (props: PackshotContainerProps) => {
  const hasLink = hasLinkProps(props)
  return hasLink ?
    <div className={cn(props.classNames, 'tst-packshot-link')} style={props.style}>
      <a aria-label={props.title} href={checkUrlType(props.link.url, 'LinkContainer')}>
        {props.children}
      </a>
    </div> :
    <div aria-label={props.title} className={props.classNames} style={props.style}>
      {props.children}
    </div>
}

export default PackshotContainer
